import "./DataHandler.js";
import "./EventListener.js";
import { Locale } from "./Locale.js";
const local = new Locale("Action");
export { Action };
/**
 * Действие. Используется для генерации пунктов меню и кнопок.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class Action {
  /**
   * Название действия.
   * @type {string}
   */
  name;

  /**
   * Тип действия.
   * @type {string}
   * @default default
   */
  type = "default";

  /**
   * Имя иконки.
   * @type {string?}
   * @see {@link Icon.jsx}
   */
  icon;

  /**
   * Ссылка для пункта меню.
   * @type {string?}
   */
  href;

  /**
   * Целевое окно для ссылок. Например, `_blank`.
   * @type {string?}
   */
  target;

  /**
   * Имя файла для загрузки.
   * @type {string?}
   */
  download;

  /**
   * Обработчик нажатия.
   * @type {(EventListener|DataHandler|null)}
   * @see {@link EventListener.js}, {@link DataHandler.js}
   */
  onClick;

  /**
   * Дополнительные классы CSS.
   * @type {string?}
   */
  className;

  /**
   * Копирует свойства объекта с валидацией.
   * @param {Object} properties - свойства объекта.
   */
  constructor(properties) {
    if (!properties.name)
      throw local.invalid("name", properties.name);
    Object.assign(this, properties);
  }

  /**
   * @return {Object} Аттрибуты ссылки.
   */
  getAnchorAttributes() {
    const attrs = {};
    if (this.href) attrs.href = this.href;
    if (this.target) attrs.target = this.target;
    if (this.download) attrs.download = this.download;
    if (this.onClick) attrs.onClick = this.onClick;
    return attrs;
  }

  /**
   * @return {Object} Аттрибуты кнопки.
   */
  getButtonAttributes() {
    const attrs = {};
    if (this.onClick) attrs.onClick = this.onClick;
    else if (this.href) attrs.onClick = (event) => {
      event.preventDefault();
      window.open(this.href, this.target || undefined);
    };
    return attrs;
  }
}
